import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import WebsiteForm from '../components/ui/WebsiteForm';
import { Website } from '../types';
import { websiteService } from '../services/api';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const WebsiteNew: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (website: Website) => {
    setLoading(true);
    setError(null);
    try {
      // Appel de l'API pour créer le site
      await websiteService.create(website);
      // Rediriger vers la liste des sites après création
      navigate('/sites');
    } catch (err: any) {
      console.error('Erreur lors de la création du site :', err);
      setError(err.response?.data?.message || 'Une erreur est survenue lors de la création du site. Veuillez réessayer.');
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/sites');
  };

  return (
    <div>
      <div className="mb-8">
        <Link to="/sites" className="text-primary-600 dark:text-primary-400 hover:underline flex items-center mb-2">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Retour à la liste
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Ajouter un site web</h1>
      </div>

      {error && (
        <div className="mb-6 bg-red-100 dark:bg-red-900 border-l-4 border-red-500 p-4 rounded-md">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <XCircleIcon className="h-5 w-5 text-red-500" />
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700 dark:text-red-200">
                {error}
              </p>
            </div>
          </div>
        </div>
      )}

      <WebsiteForm 
        onSubmit={handleSubmit} 
        onCancel={handleCancel}
        isSubmitting={loading} 
      />
    </div>
  );
};

export default WebsiteNew; 